$(document).ready(function () {
    if($('.testimonial-slider__inner').length > 0) {
        var arrows = $('.testimonial-slider__inner').data('arrows');
        var autoplay = $('.testimonial-slider__inner').data('autoplay');
        var dots = $('.testimonial-slider__inner').data('dots');

        $('.testimonial-slider__inner').slick({
            slidesToShow: 3,
            dots: dots,
            infinite: true,
            adaptiveHeight: false,
            autoplay: autoplay,
            arrows: arrows,
            prevArrow: '<button type="button" class="slick-prev"><svg aria-hidden="true" focusable="false" class="icon icon-caret" viewBox="0 0 10 6"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></path></svg></button>',
            nextArrow: '<button type="button" class="slick-next"><svg aria-hidden="true" focusable="false" class="icon icon-caret" viewBox="0 0 10 6"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"> </path></svg></button>',
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        arrows: false
                    }
                }
            ]
        });
    }
});